import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

const NoResponders = ({ type }: { type: 'cover' | 'trade' }) => (
  <Box column gap={8} p={16} tcenter>
    <Text
      variant="bodyBold"
      i18n={`requests_feed.${type}.details.no_claims_yet`}
    />
    <Text
      variant="bodySm"
      color="mono500"
      i18n={`requests_feed.${type}.details.no_claims_yet_description`}
    />
  </Box>
);

export default NoResponders;
